import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return { color: 'bg-green-100 text-green-800', label: 'Active' };
      case 'spare':
        return { color: 'bg-blue-100 text-blue-800', label: 'Spare' };
      case 'repair':
        return { color: 'bg-yellow-100 text-yellow-800', label: 'Under Repair' };
      case 'retired':
        return { color: 'bg-gray-100 text-gray-800', label: 'Retired' };
      default:
        return { color: 'bg-gray-100 text-gray-800', label: status || 'Unknown' };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;